export default __webpack_public_path__ + "static/media/sploteam-cooperation@2x.ff9e5337.png";